<template>
    <div class="flex flex-col min-h-screen overflow-hidden">
  
      <!-- Site header -->
      <SiteHeader />
  
      <!-- Page content -->
      <main class="flex-grow">
  
        <div class="max-w-6xl mx-auto px-4 sm:px-6">
        <div class="pt-32 pb-12 md:pt-2 md:pb-2">
          <div class="max-w-3xl mx-auto lg:max-w-none">

            <article>
            <!-- button back to blog --> 
            


            <!-- Article header -->
            <header class="max-w-3xl mx-auto mb-20">
                        
    <div class="blog">
        
        <div v-for="(section, index) in Object.keys(entries)" :key="index" class="group">
            <div v-if="session == 'all' || section == session">
        <h2 class="h5">{{section | capitalizeAll }}</h2>
        <div class="section" v-for="entry in entries[section]" :key="entry.id">
            <router-link :to="`/${section}/${entry.id}`" tag="a">
          <div class="entry">
            <h3>
              {{entry.title}}
            </h3>
            <span class="subtitle">{{entry.date}}</span>
            <p>{{entry.description}}</p>
          </div>
          </router-link>
        </div>
    </div>
      </div>

    </div>

</header>
</article>

    </div>
    </div>
    </div>
  
      </main>
  
      <!-- Site footer -->
      <Footer />
  
    </div>
  </template>
  
  <script>
  import SiteHeader from './../partials/Header.vue'
  import Footer from './../partials/Footer.vue'
  import Contents from '@/statics/contents.json'

  export default {
    name: 'BlogPost',
    props: {
        session: {
            type: String,
            default: 'all'
        }
    },
    data() {
      return {
        session_name: 'blog'
      }
    },
    components: {
      SiteHeader,
      Footer,
    },
    computed: {
        entries() {
            return Contents
        }
    },
    filters: {
        capitalize: function (value) {
          if (!value) return ''
          value = value.toString()
          return value.charAt(0).toUpperCase() + value.slice(1)
        },
        capitalizeAll: function (value) {
          if (!value) return ''
          value = value.toString()
          return value.split('-').map(function(item) {
            return item.charAt(0).toUpperCase() + item.slice(1)
          }).join(' ')
        }
    },
    mounted() {
        this.session_name = this.$route.path.split('/')[1]
    }
  }
  </script>
  
  <style lang="scss" scoped>
  .blog {
    max-width: 50vw;
    margin: 6rem auto;
  
    .back {
      background-color: #42b883;
      color: white;
      margin-top: 5rem;
      text-decoration: none;
      padding: 10px 15px;
      border: 1px solid currentColor;
      border-radius: .5rem;
      display: inline-block;
      transition: all .3s ease;
      &:hover {
        background-color: transparent;
        color: #42b883;
      }
    }
    
      h1 {
        font-size: 3rem;
        margin-bottom: .2rem;
        color: #42b883;
      }
      h4 {
        margin-bottom: 3rem;
        color: #35495e;
      }
      pre {
        overflow-x: auto;
        background-color: #35495e;
        color: black;
        border-radius: .3rem;
        padding: 1rem;
      }
      img {
        max-width: 100%;
      }
    }
  
  </style>